import BrochureRequest from "../../../components/units/Edgecross/Brochure";

export default function BrochureRequestPage() {
  return <BrochureRequest />;
}
